import { doc, getDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

export interface ReferralStatsSnapshot {
  successfulCount: number;
  monthsEarned: number;
}

/** OW-515 — read server counters. Missing field is a real zero. Throw on read failure. */
export async function loadReferralStats(uid: string): Promise<ReferralStatsSnapshot> {
  const snap = await getDoc(doc(db, 'Users', uid));
  if (!snap.exists()) {
    throw new Error('User document missing');
  }
  const raw = snap.data().referralStats as
    | { successfulCount?: unknown; monthsEarned?: unknown }
    | undefined;
  const successful = Number(raw?.successfulCount ?? 0);
  const months = Number(raw?.monthsEarned ?? 0);
  return {
    successfulCount: Number.isFinite(successful) ? Math.max(0, successful) : 0,
    monthsEarned: Number.isFinite(months) ? Math.max(0, months) : 0,
  };
}
